import React, { Children, useContext, useEffect } from 'react'
import Navigation from '../Components/Shared/Navigation'
import modalContext from '../context/ModalContext'
import DetailModal from '../modals/DetailModal';
import ProfileModal from '../modals/ProfileModal';
import {makeAuthenticatedGETRequest} from '../utils/endPointCalling';
import Loader from '../Components/Shared/Loader';

function LoggedInUi({children}) {
  const {showModal, setShowModal} = useContext(modalContext);
  const {modalDetails, setModalDetails} = useContext(modalContext);
  const {profileDetails, setProfileDetails, modal, setModal, load, setLoad} = useContext(modalContext);

  useEffect(()=>{
    const getData = async () => {
      const response = await makeAuthenticatedGETRequest('/auth/my/details');
      console.log(response);
      setProfileDetails(response.data);
    }
    getData();
  },[]);

  return (
    <div style={{backgroundColor: '#F8F8FF'}} className='w-full h-screen flex flex-col overflow-hidden flex-grow'>
          {showModal && <DetailModal item={modalDetails} onClose={()=>{setShowModal(false)}} />}
          {modal && <ProfileModal />}
          {load && <Loader />}
        <div className='h-1/10'>
        <Navigation />
        </div>
        <div className='h-[90%] w-full flex flex-col flex-grow overflow-auto'>
          {children}
        </div>
    </div>
  )
}

export default LoggedInUi